import { isNullOrEmpty, stopPropagation } from "../../../helpers/ObjectHelpers";
import { ICardDispatcherService } from "./ICardDispatcherService";

class CardDispatcherService implements ICardDispatcherService {

    _id: number = 0;
    _setIsSelected: (isSelected: boolean) => void = () => { };
    _isSelected: boolean = false;
    _onClick: (() => void) | null = null;
    _onAccept: (() => void) | null = null;
    _onSelect: ((id: number, selected: boolean, systemName?: string) => void) | null = null;
    _onToggleSelect: (() => void) | null = null;
    _onActivateSelect: ((id:number) => void) | null = null;
    _onDeactivateSelect: ((id: number) => void) | null = null;
    _onDelete: (() => void) | null = null;
    _confirmDelete: boolean = false;
    _setShowDialog: (showDialog: boolean) => void = () => { };
    _systemName: string = "";
    _allowBothSelectAndClick: boolean = false;

    constructor(
        id: number = 0,
        setIsSelected: (isSelected: boolean) => void = () => { },
        onClick: (() => void) | null = null,
        onAccept: (() => void) | null = null,
        onSelect: ((id: number, selected: boolean) => void) | null = null,
        onToggleSelect: (() => void) | null = null,
        onActivateSelect: ((id:number) => void) | null = null,
        onDeactivateSelect: ((id: number) => void) | null = null,
        onDelete: (() => void) | null = null,
        confirmDelete: boolean = false,
        setShowDialog: (showDialog: boolean) => void = () => { },
        systemName: string = "",
        allowBothSelectAndClick: boolean = false,
    ) { 
        this._id = id;
        this._setIsSelected = setIsSelected;
        this._onClick = onClick;
        this._onAccept = onAccept;
        this._onSelect = onSelect;
        this._onToggleSelect = onToggleSelect;
        this._onActivateSelect = onActivateSelect;
        this._onDeactivateSelect = onDeactivateSelect;
        this._onDelete = onDelete;
        this._confirmDelete = confirmDelete;
        this._setShowDialog = setShowDialog;
        this._systemName = systemName;
        this._allowBothSelectAndClick = allowBothSelectAndClick;
    }

    onAccept(e: any): void {
        if (e) {
            stopPropagation(e);
        }
        if (!this._onAccept) return;
        this._onAccept();
    }

    setOnDelete(onDelete: (() => void) | null) {
        this._onDelete = onDelete;
    }

    onClick(isLeadingActionsOpened: boolean, cancelOnTouchEndOrOnMouseUp: boolean) {

        if (cancelOnTouchEndOrOnMouseUp) return;

        // New logic: if allowBothSelectAndClick is true, always call onClick regardless of leading actions state
        if (this._allowBothSelectAndClick) {
            if (!this._onClick) return;
            this._onClick();
        } else {
            // Original logic
            if (isLeadingActionsOpened) {
                this._setIsSelected(!this._isSelected);
            } else {
                if (!this._onClick) return;
                this._onClick();
            }
        }
    }

    onSelect(select: boolean) {
        if (!this._onSelect || this._isSelected === select) return;

        this._setIsSelected(select);
        
        this._isSelected = select;
        
        if (!isNullOrEmpty(this._systemName)) {
            this._onSelect(this._id, select, this._systemName);
        } else {
            this._onSelect(this._id, select);
        }
    }

    onToggleSelect() {
        if (!this._onToggleSelect) return;
        this._onToggleSelect();
    }

    onActivateSelect() {
        if (!this._onActivateSelect) return;
        this._onActivateSelect(this._id);
    }

    onDeactivateSelect() {
        if (!this._onDeactivateSelect) return;
        this._onDeactivateSelect(this._id);
        this._setIsSelected(false);
    }

    onAccecpt(e: any) {
        if (e) {
            stopPropagation(e);
        }
        if (!this._onAccept) return;
        this._onAccept();
    }

    onDelete(e: any) {
        if (e) {
            stopPropagation(e);
        }
        if (this._confirmDelete) {
            this._setShowDialog(true);
        } else {
            this.onThenDelete();
        }
    }

    onThenDelete() {
        this._setShowDialog(false);
        if (!this._onDelete) return;
        this._onDelete();
    }
}

export default CardDispatcherService;
